<template>
  <sideBarView />

  <navbarView />

  <main class="main-sec" id="main">
    <div class="container">
      <div class="flex-bet-main mb-3">
        <div class="side-heading">
          <h6>
            <router-link to="/" class="black">{{ $t('orderDetails.managementOrders') }}</router-link> /
            <span class="color-main">{{ $t('orderDetails.newOrderDetails') }}</span>
          </h6>
          <p class="font13 gray-col">{{ $t('orderDetails.moreAboutSaqf') }}</p>
        </div>
        <!-- <div class="flex-sm-gap def-wid">
          <router-link
            :to="{ name: 'editBuilding', params: { id: route.params.id } }"
            class="main-btn up"
          >
            تعديل العقار
          </router-link>
          <button
            class="main-btn up bg-red"
            type="button"
            @click="confirmRemove = true"
          >
            حذف العقار
          </button>
        </div> -->
      </div>
      <div class="details-card mb-4">
        <div class="card-details-title">{{ $t('orderDetails.orderData') }}</div>
        <div class="card-rows">
          <div class="flex-loop-row">
            <div class="first-info gray-col">رقم الطلب</div>
            <div class="second-info">{{ building_id }}</div>
          </div>
          <div class="flex-loop-row">
            <div class="first-info gray-col">{{ $t('orderDetails.additionDate') }}</div>
            <div class="second-info">{{ date }}</div>
          </div>
          <div class="flex-loop-row">
            <div class="first-info gray-col">{{ $t('orderDetails.buildingName') }}</div>
            <div class="second-info">{{ name }}</div>
          </div>
          <div class="flex-loop-row">
            <div class="first-info gray-col">{{ $t('orderDetails.buildingType') }}</div>
            <div class="second-info">{{ type }}</div>
          </div>
          <div class="flex-loop-row">
            <div class="first-info gray-col">{{ $t('orderDetails.buildingAge') }}</div>
            <div class="second-info">{{ age }}</div>
          </div>
          <div class="flex-loop-row">
            <div class="first-info gray-col">{{ $t('orderDetails.buildingArea') }}</div>
            <div class="second-info">
              {{ area }}
            </div>
          </div>
          <div class="flex-loop-row">
            <div class="first-info gray-col">{{ $t('orderDetails.tenantsCount') }}</div>
            <div class="second-info">{{ count }}</div>
          </div>
          <div class="flex-loop-row">
            <div class="first-info gray-col">{{ $t('orderDetails.buildingAddress') }}</div>
            <div class="second-info">
              <i class="fa-solid fa-location-dot color-main"></i> &nbsp;
              {{ address }}
            </div>
          </div>
          <div
            class="flex-loop-row"
            v-if="status_step == 1 || status_step == 4"
          >
            <div class="first-info gray-col">{{ $t('orderDetails.buildingUse') }}</div>
            <div class="second-info">{{ use }}</div>
          </div>
          <div
            class="flex-loop-row"
            v-if="status_step == 1 || status_step == 4"
          >
            <div class="first-info gray-col">{{ $t('orderDetails.buildingCode') }}</div>
            <div class="second-info">{{ code }}</div>
          </div>
          <div
            class="flex-loop-row"
            v-if="status_step == 1 || status_step == 4"
          >
            <div class="first-info gray-col">{{ $t('orderDetails.agreedRatio') }}</div>
            <div class="second-info">{{ percent }}</div>
          </div>
          <div
            class="flex-loop-row"
            v-if="status_step == 1 || status_step == 4"
          >
            <div class="first-info gray-col">{{ $t('orderDetails.apartmentsCount') }}</div>
            <div class="second-info">{{ number }}</div>
          </div>
        </div>
      </div>
      <div class="card-details-def mb-4">
        <h6 class="color-main mb-2">{{ $t('orderDetails.buildingDescription') }}</h6>
        <p class="gray-col">
          {{ desc }}
        </p>
      </div>
      <div class="card-details-def" v-if="owner">
        <h6 class="color-main mb-3">{{ $t('orderDetails.ownerData') }}</h6>
        <div class="flex-sm-gap mb-3">
          <img :src="userImg" class="img-user" alt="" />
          <div class="user-data-card">
            <div class="color-main mb-2">{{ ownerName }}</div>
            <a href="tel:01097054537" target="_blank" class="phone-info black">
              <div class="phone-icon"><i class="fa-solid fa-phone"></i></div>
              {{ ownerPhone }}
            </a>
          </div>
        </div>
      </div>
      <div class="mt-3 mb-3" v-if="status_step == 1 || status_step == 4" >
        <router-link
          :to="{ name: 'tenantsView', params: { id: route.params.id } }"
          class="tenants"
        >
          <div>
            {{ $t('orderDetails.tenants') }} <strong >({{ tenants }})</strong>
          </div>
          <i class="fa-solid fa-angle-left"></i>
        </router-link>
      </div>
      <div class="card-details-def" v-if="status_step == 1 || status_step == 4">
        <div class="flex-bet-file mb-3">
          <div class="flex-sm-gap">
            <div class="file-cont">
              <img :src="fileImg" class="fileImg" alt="" />
            </div>
            <div>{{ $t('orderDetails.managementContract') }}</div>
          </div>
          <a :href="down1" target="_blank" download class="downloadlink"
            >{{ $t('orderDetails.downloadContract') }}</a
          >
        </div>
        <div class="flex-bet-file mb-3">
          <div class="flex-sm-gap">
            <div class="file-cont">
              <img :src="fileImg" class="fileImg" alt="" />
            </div>
            <div>{{ $t('orderDetails.propertyDeed') }}</div>
          </div>
          <a :href="down2" target="_blank" download class="downloadlink"
            >{{ $t('orderDetails.downloadDeed') }}</a
          >
        </div>
        <div class="flex-bet-file mb-3">
          <div class="flex-sm-gap">
            <div class="file-cont">
              <img :src="fileImg" class="fileImg" alt="" />
            </div>
            <div>{{ $t('orderDetails.constructionCertificate') }}</div>
          </div>
          <a :href="down3" target="_blank" download class="downloadlink"
            >{{ $t('orderDetails.downloadCertificate') }}</a
          >
        </div>
        <div class="flex-bet-file mb-3">
          <div class="flex-sm-gap">
            <div class="file-cont">
              <img :src="fileImg" class="fileImg" alt="" />
            </div>
            <div>{{ $t('orderDetails.civilDefenseCertificate') }}</div>
          </div>
          <a :href="down4" target="_blank" download class="downloadlink"
            >{{ $t('orderDetails.downloadCertificate') }}</a
          >
        </div>
      </div>
      <div class="flex-sm-gap mt-3" v-if="status_step == 0">
        <button class="main-btn up xl" type="button" @click="acceptOrder">
          {{ $t('orderDetails.acceptAndAddBuilding') }}
        </button>
        <button
          class="main-btn up xl bg-red"
          type="button"
          @click="showRefuse = true"
        >
          {{ $t('orderDetails.closeRequestWithoutAgreement') }}
        </button>
      </div>
      <div class="flex-sm-gap mt-3" v-if="status_step == 1">
        <button
          class="main-btn up xl bg-red"
          type="button"
          @click="confirmRemove = true"
        >
          {{ $t('orderDetails.finishContract') }}
        </button>
      </div>
    </div>
  </main>

  <!-- success modal  -->
  <Dialog v-model:visible="showSuccess" modal :style="{ width: '500px' }">
    <div class="modal-body-main modal-pad">
      <div class="flex-group-me mb-4 mt-4">
        <img :src="successImg" class="successImg" alt="" />
      </div>
      <h6 class="font-bold text-center black font17 mb-4">
        {{ $t('orderDetails.orderAcceptedSuccess') }}
      </h6>
    </div>
  </Dialog>
  <!-- refuse modal  -->
  <Dialog v-model:visible="showRefuse" modal :style="{ width: '50vw' }">
    <div class="modal-body-main modal-pad modal-pad-refuse">
      <v-form @submit.prevent="refuse" v-model="valid" ref="form">
        <div class="title-modal mt-3 mb-2">{{ $t('orderDetails.rejectionReason') }}</div>
        <v-textarea
          :rules="defaultRoles"
          name="cancel_reason"
          rows="10"
          :placeholder="$t('orderDetails.rejectionReasonPlaceholder')"
        ></v-textarea>
        <div class="flex-group-me">
          <button type="submit" :disabled="disabled" class="main-btn up lg">
            <div v-if="!disabled">{{ $t('orderDetails.closeRequest') }}</div>
            <div class="loading" role="status" v-if="disabled">
              {{ $t('orderDetails.confirming') }}
              <div class="spinner-small-white" v-if="disabled"></div>
            </div>
          </button>
        </div>
      </v-form>
    </div>
  </Dialog>
  <!-- success modal  -->
  <Dialog v-model:visible="suceessRefuse" modal :style="{ width: '420px' }">
    <div class="modal-body-main modal-pad">
      <div class="flex-group-me mb-4 mt-3">
        <img :src="successImg" class="successImg" alt="" />
      </div>
      <h6 class="font-bold text-center black font17 mb-4">
        {{ $t('orderDetails.requestClosedSuccess') }}
      </h6>
      <div class="flex-group-me mb-3">
        <router-link to="/dashboardHome" class="main-btn lg up"
          >{{ $t('orderDetails.home') }}</router-link
        >
      </div>
    </div>
  </Dialog>
  <!-- success finish modal  -->
  <Dialog v-model:visible="successfinish" modal :style="{ width: '520px' }">
    <div class="modal-body-main modal-pad">
      <div class="flex-group-me mb-4 mt-3">
        <img :src="successImg" class="successImg" alt="" />
      </div>
      <h6 class="font-bold text-center black font17 mb-4">
        {{ $t('orderDetails.contractFinishedSuccess', { name: name }) }}
      </h6>
      <div class="flex-group-me mb-3">
        <router-link to="/managementOrders" class="main-btn lg up"
          >{{ $t('orderDetails.followOrders') }}</router-link
        >
        <router-link to="/dashboardHome" class="main-btn lg up bg-trans"
          >{{ $t('orderDetails.home') }}</router-link
        >
      </div>
    </div>
  </Dialog>
  <!-- confirm modal  -->
  <Dialog v-model:visible="confirmRemove" modal :style="{ width: '520px' }">
    <div class="modal-body-main modal-pad">
      <div class="flex-group-me mb-4 mt-3">
        <img :src="dangerImg" class="successImg" alt="" />
      </div>
      <h6 class="font-bold text-center black font17 mb-4">
        هل انت متاكد من انهاء التعاقد؟
      </h6>
      <div class="flex-group-me mb-3">
        <button
          type="button"
          :disabled="disabled"
          class="main-btn lg up bg-red"
          @click="finishContract"
        >
          <div v-if="!disabled">{{ $t('orderDetails.yesDelete') }}</div>
          <div class="loading" role="status" v-if="disabled">
            {{ $t('orderDetails.deleting') }}
            <div class="spinner-small-white" v-if="disabled"></div>
          </div>
        </button>
        <button
          type="button"
          class="main-btn lg up bg-trans"
          @click="confirmRemove = false"
        >
          {{ $t('orderDetails.cancel') }}
        </button>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
// imports
import sideBarView from "../components/dashboard/sideBarView.vue";
import navbarView from "../components/dashboard/navbarView.vue";

import { ref, onMounted } from "vue";
import Dialog from "primevue/dialog";
// reactive state
import axios from "axios";
import { useToast } from "primevue/usetoast";
import { useRouter } from "vue-router";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
const toast = useToast();
const router = useRouter();
const route = useRoute();
const { t } = useI18n();

// reactive state
const userImg = ref(
  require("../assets/imgs/185644495_1667380803456791_1968050560740665054_n.jpg")
);
const dangerImg = ref(require("../assets/imgs/noun_warning.png"));
const fileImg = ref(require("../assets/imgs/pdf.png"));
const successImg = ref(require("../assets/imgs/check.png"));

const form = ref(null);
const owner = ref(true);
const valid = ref(false);
const showSuccess = ref(false);
const showRefuse = ref(false);
const suceessRefuse = ref(false);
const successfinish = ref(false);
const confirmRemove = ref(false);

//  refs details
const disabled = ref(false);
const status_step = ref(null);
const name = ref("");
const type = ref("");
const date = ref("");
const building_id = ref("");
const age = ref("");
const area = ref("");
const count = ref("");
const address = ref("");
const use = ref("");
const code = ref("");
// const ref_code = ref("");
const percent = ref("");
const number = ref("");
const desc = ref("");
const down1 = ref("");
const down2 = ref("");
const down3 = ref("");
const down4 = ref("");
const ownerName = ref("");
const ownerPhone = ref("");
const tenants = ref("");
const shops_count = ref("");
const defaultRoles = ref([
  (value) => {
    if (value) return true;

    return t('orderDetails.rejectionReasonRequired');
  },
]);

// functions
// refuse
function acceptOrder() {
  showSuccess.value = true;
  setTimeout(function () {
    router.push(`/completeBuilding/${route.params.id}`);
  }, 1500);
}
function refuse() {
  if (valid.value) {
    refuseMain();
  }
}

function finishContract() {
  disabled.value = true;
  const fd = new FormData();

  axios
    .post(`manager/finish-building-contract/${route.params.id}`, fd, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      if (response.data.key == "success") {
        confirmRemove.value = false;
        successfinish.value = true;
        setTimeout(function () {
          router.push("/dashboardHome");
        }, 1500);
      } else {
        toast.add({
          severity: "error",
          detail: `${response.data.msg}`,
          life: 3000,
        });
      }
      disabled.value = false;
    });
}
function refuseMain() {
  disabled.value = true;
  const fd = new FormData(form.value.$el);
  fd.append("order_id", route.params.id);

  axios
    .post(`manager/cancel-order`, fd, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      if (response.data.key == "success") {
        showRefuse.value = false;
        suceessRefuse.value = true;
        setTimeout(function () {
          router.push("/dashboardHome");
        }, 1500);
      } else {
        toast.add({
          severity: "error",
          detail: `${response.data.msg}`,
          life: 3000,
        });
      }
      disabled.value = false;
    });
}

function getBuilding() {
  axios
    .get(`/manager/management-order-details/${route.params.id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      status_step.value = response.data.data.status_step;
      name.value = response.data.data.name;
      type.value = response.data.data.type.name;
      date.value = response.data.data.created_at;
      building_id.value = response.data.data.building_id;
      age.value = response.data.data.age_text;
      area.value = response.data.data.area_text;
      count.value = response.data.data.users_count;
      address.value = response.data.data.map_desc;
      address.value = response.data.data.map_desc;
      use.value = response.data.data.specification;
      code.value = response.data.data.ref_code;
      percent.value = response.data.data.ratio_text;
      number.value = response.data.data.units_count;
      desc.value = response.data.data.description;
      shops_count.value = response.data.data.shops_count;
      if (response.data.data.owner) {
        owner.value = true;
        userImg.value = response.data.data.owner.image;
        ownerName.value = response.data.data.owner.name;
        ownerPhone.value = response.data.data.owner.phone;
      } else {
        owner.value = false;
      }
      tenants.value = response.data.data.rentals_count;
      down1.value = response.data.data.contract;
      down2.value = response.data.data.instrument;
      down3.value = response.data.data.construction_completion_certificate;
      down4.value = response.data.data.civil_defense_certificate;
    });
}

// lifecycle hooks
onMounted(() => {
  getBuilding();
});
</script>
